module.exports = __webpack_public_path__ + "static/media/removebg-preview.48aecb0d.png";